import { useMutation } from '@tanstack/react-query';

import Api from '@app/services/api';
import { ICertificate } from '@app/services/cades/interfaces';

export const useSigningContext = () =>
  useMutation({
    mutationFn: (certificates: ICertificate[]) =>
      Api.orders.postEpdSigningContext({
        certificates: certificates
          .filter((item) => item.valid && item.hasPrivateKey)
          .map((item) => ({
            thumbprint: item.thumbprint,
            snils: item.identity.snils || null,
            inn: item.identity.inn || null,
            organization_inn: item.identity.innLe || null,
            last_name: item.identity.lastName || null,
            given_names: [item.identity.firstName, item.identity.middleName].filter(Boolean).join(' ') || null,
          })),
      }),
    retry: false,
  });
